import React, { Component } from 'react';
import i18n from '../../i18n';
import { compose } from 'redux';
import { connect } from 'react-redux';
import Immutable from 'seamless-immutable';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import { withSize } from 'react-sizeme';
import { Metrics, Colors } from '../../themes';
import clsx from 'clsx';
import Select from '../common/Select';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import AccessLevelsActions from '../../redux/AccessLevelsRedux';
import TagsActions from '../../redux/TagsRedux';
import TagTypesActions from '../../redux/TagTypesRedux';
import Button from '@material-ui/core/Button';
import { hackToAddOffset, isTagValid } from '../../lib/Utils';
import { addHours } from 'date-fns';
import SnackbarNotification from '../common/SnackbarNotification';
import AlertDialog from '../common/AlertDialog';

const styles = (theme) => ({
  widgetContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    height: Metrics.widgetMinHeight,
  },
  title: {
    textAlign: 'left',
    padding: theme.spacing(4),
    paddingBottom: 0,
  },
  selectorContainer: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    borderRadius: '4px 4px 0 0',
  },
  textField: {
    marginTop: 10,
  },
  select: {
    marginTop: -2,
  },
  buttonsRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    overflow: 'hidden',
    margin: 20,
    flexWrap: 'wrap',
    overflowY: 'auto',
    marginRight: 10,
    paddingRight: 10,
    marginTop: 'auto',
  },
  button: {
    flex: 1,
    fontWeight: 600,
    fontSize: 16,
    margin: theme.spacing(2),
  },
  clearButton: {
    color: Colors.white,
    border: `1px solid ${Colors.disabledGrey}`,
    '&:hover': {
      background: Colors.disabledGrey,
    },
  },
  activateTagButton: {
    background: Colors.blue,
    flex: 1,
    '&:hover': {
      background: Colors.lightBlue,
    },
    '&:disabled': {
      border: `1px solid ${Colors.disabledGrey}`,
      color: Colors.disabledGrey,
      background: Colors.hoverGrey,
    },
  },
});

class ActivateTag extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tagUid: '',
      tagTypeId: '',
      accessLevelId: '',
      isTagUidError: false,
      tagUidHelperText: null,
      isTagTypeError: false,
      tagTypeHelperText: null,
      isAccessLevelError: false,
      accessLevelHelperText: null,
      isUntouched: true,
      isFormValid: false,
      minTime: new Date().toJSON(),
      maxTime: null,
      activateDelay: null,
      requirePinCode: null,
      accessLeft: '',
      // alert confirm dialog
      isAlertDialogOpen: false,
      alertContentText: '',
      alertConfirmAction: null,
      //snackbar
      isSnackbarNotificationOpen: false,
      snackbarVariant: 'warning',
      snackbarMessage: '',
    };
  }

  componentDidMount() {
    if (this.props.customerId) {
      this.sendGetAccessLevelsRequest();
      this.sendGetTagTypesRequest();
    }
  }

  componentWillUnmount() {
    this.props.resetTagTypes();
    this.props.resetAccessLevels();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.customerId !== this.props.customerId) {
      this.setState({ tagUid: '', tagTypeId: '', accessLevelId: '' });
      this.props.resetTagTypes();
      this.props.resetAccessLevels();
      if (this.props.customerId) {
        this.sendGetTagTypesRequest();
        this.sendGetAccessLevelsRequest();
      }
    }
    if (
      prevState.tagUid !== this.state.tagUid ||
      prevState.tagTypeId !== this.state.tagTypeId ||
      prevState.accessLevelId !== this.state.accessLevelId
    ) {
      this.validate();
    }

    if (prevProps.tagIsLoading && !this.props.tagIsLoading) {
      if (this.props.tagSuccessMessage) {
        this.setState({
          isSnackbarNotificationOpen: true,
          snackbarVariant: 'success',
          snackbarMessage: this.props.tagSuccessMessage,
        });
      }
      if (this.props.tagErrorMessage) {
        this.setState({
          isSnackbarNotificationOpen: true,
          snackbarVariant: 'error',
          snackbarMessage: this.props.tagErrorMessage,
        });
      }
    }
  }

  sendGetAccessLevelsRequest = () => {
    const pageParams = {
      items: -1,
      page: 0,
      value: null,
    };
    this.props.getAccessLevels(this.props.customerId, pageParams);
  };

  sendGetTagTypesRequest = () => {
    const pageParams = {
      items: -1,
      page: 0,
      value: null,
    };
    this.props.getTagTypes(this.props.customerId, pageParams);
  };

  activateTag = () => {
    const {
      tagUid,
      tagTypeId,
      accessLevelId,
      accessLeft,
      minTime,
      maxTime,
      activateDelay,
      requirePinCode,
    } = this.state;
    const tagInfos = {
      tagUid,
      tagTypeId,
      accesslevels: [{ accessLevelId }],
      minTime: hackToAddOffset(minTime),
      maxTime: hackToAddOffset(maxTime),
      accessLeft: accessLeft ? accessLeft : -100,
      personId: 'UNKNOWN', // TODO: when backend refactored to have default personId, do not pass personId
      customerId: this.props.customerId,
      ...(activateDelay && { activateDelay }),
      ...(requirePinCode && { requirePinCode }),
    };
    if (isTagValid(tagUid)) {
      this.props.activateTag(tagInfos);
      this.setState({ tagUid: '', isUntouched: true });
    } else {
      this.setState({
        isAlertDialogOpen: true,
        alertContentText: i18n.t('alert.createTagContent', { tagUid }),
        alertConfirmAction: () => {
          this.props.activateTag(tagInfos);
          this.setState({ tagUid: '', isUntouched: true, isAlertDialogOpen: false });
        },
      });
    }
  };

  handleBlur = (event) => {
    this.setState({ isUntouched: false });
  };

  validate = () => {
    if (this.state.isUntouched) {
      this.setState({ isUntouched: false });
    }
    const helperText = this.props.t('validation.requiredField');
    if (!this.state.isUntouched) {
      if (!this.state.tagUid) {
        this.setState({ isTagUidError: true, tagUidHelperText: helperText, isFormValid: false });
      } else if (this.state.tagUid) {
        this.setState({ isTagUidError: false, tagUidHelperText: null });
      }
      if (!this.state.tagTypeId) {
        this.setState({ isTagTypeError: true, tagTypeHelperText: helperText, isFormValid: false });
      } else if (this.state.tagTypeId) {
        this.setState({ isTagTypeError: false, tagTypeHelperText: null });
      }
      if (!this.state.accessLevelId) {
        this.setState({ isAccessLevelError: true, accessLevelHelperText: helperText, isFormValid: false });
      } else if (this.state.accessLevelId) {
        this.setState({ isAccessLevelError: false, accessLevelHelperText: null });
      }
      if (this.state.tagUid && this.state.tagTypeId && this.state.accessLevelId) {
        this.setState({ isFormValid: true });
      }
    }
  };

  handleSelectTagType = (tagTypeId) => {
    const selectedTagTypeData = this.props.tagTypes.find((tagType) => tagType.tagTypeId === tagTypeId);
    const {
      defaultActivateDelay,
      defaultCounterValue,
      defaultFutureTimeValue,
      defaultRequirePinCode,
    } = selectedTagTypeData;
    const maxTime = defaultFutureTimeValue >= 0 ? addHours(new Date(), defaultFutureTimeValue).toJSON() : null;
    this.setState({
      tagTypeId,
      accessLeft: defaultCounterValue >= 0 ? defaultCounterValue : '',
      activateDelay: defaultActivateDelay,
      requirePinCode: defaultRequirePinCode,
      maxTime,
    });
  };

  handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      this.activateTag();
    }
  };

  handleAccessLevelsKeyDown = (event) => {
    if (event.key === 'Enter' && this.state.tagUid && this.state.tagTypeId) {
      this.activateTag();
    }
  };

  render() {
    const isSmall = this.props.size.width < Metrics.tableWidth.small;
    const fullWidth = this.props.size.width - 40;
    const elementWidth = isSmall ? fullWidth : (this.props.size.width - 60) / 2;
    const { t, classes } = this.props;
    const accessLevelsData = Immutable.asMutable(this.props.accessLevels).sort((a, b) => a.name.localeCompare(b.name));
    const tagTypesData = Immutable.asMutable(this.props.tagTypes).sort((a, b) => a.name.localeCompare(b.name));

    return (
      <div className={classes.widgetContainer}>
        <AlertDialog
          open={this.state.isAlertDialogOpen}
          handleClose={() => this.setState({ isAlertDialogOpen: false })}
          title={i18n.t('alert.createTagTitle')}
          contentText={this.state.alertContentText}
          cancelButtonText={t('Global_cancel')}
          confirmButtonText={t('Global_create')}
          onConfirm={this.state.alertConfirmAction}
        />
        <SnackbarNotification
          open={this.state.isSnackbarNotificationOpen}
          variant={this.state.snackbarVariant}
          message={this.state.snackbarMessage}
          close={() => this.setState({ isSnackbarNotificationOpen: false })}
        />
        <div className={classes.title}>
          <Typography variant="h2" className={classes.label}>
            {t('framesIndex_widget_activateTag')}
          </Typography>
        </div>
        <form
          noValidate
          autoComplete="off"
          className={classes.selectorContainer}
          onSubmit={(e) => e.preventDefault()}
          onKeyPress={(event) => this.handleKeyPress(event)}
        >
          <TextField
            style={{ width: fullWidth }}
            id="tagUid"
            className={classes.textField}
            label={t('widgetActivateTag_tagNo_placeholder')}
            name="tagUid"
            margin="normal"
            value={this.state.tagUid}
            onChange={(event) => this.setState({ [event.target.name]: event.target.value })}
            required
            onBlur={this.handleBlur}
            error={this.state.isTagUidError}
            helperText={this.state.tagUidHelperText}
          />
          <Select
            lowMarginTop={isSmall}
            selectData={tagTypesData}
            className={classes.select}
            id="tagTypes"
            selectLabel={t('widgetActivateTag_tagType_placeholder')}
            selectValue={this.state.tagTypeId}
            onSelect={(tagTypeId) => this.handleSelectTagType(tagTypeId)}
            accessValue={'tagTypeId'}
            accessLabel={'name'}
            selectWidth={elementWidth}
            disabled={!this.props.tagTypes || this.props.tagTypes.length === 0}
            noEntry={t('widgetActivateTag_tagType_no_tagType')}
            required
            error={this.state.isTagTypeError}
            onBlur={this.handleBlur}
            helperText={this.state.tagTypeHelperText}
          />
          <Select
            selectData={accessLevelsData}
            className={classes.select}
            id="accessLevels"
            selectLabel={t('personManager_tags_col2')}
            selectValue={this.state.accessLevelId}
            onSelect={(accessLevelId) => this.setState({ accessLevelId })}
            accessValue={'accessLevelId'}
            accessLabel={'name'}
            selectWidth={elementWidth}
            disabled={!this.props.accessLevels || this.props.accessLevels.length === 0}
            noEntry={t('accessLevels.noAccessLevel')}
            required
            error={this.state.isAccessLevelError}
            onBlur={this.handleBlur}
            helperText={this.state.accessLevelHelperText}
            onKeyDown={this.handleAccessLevelsKeyDown}
          />
        </form>

        <div className={classes.buttonsRow}>
          <Button
            onClick={() =>
              this.setState({
                tagUid: '',
                tagTypeId: '',
                accessLevelId: '',
                isUntouched: true,
                isTagUidError: false,
                tagUidHelperText: null,
                isTagTypeError: false,
                tagTypeHelperText: null,
                isAccessLevelError: false,
                accessLevelHelperText: null,
              })
            }
            className={clsx(classes.button, classes.clearButton)}
          >
            {t('Global_clear')}
          </Button>
          <Button
            onClick={this.activateTag}
            className={clsx(classes.button, classes.activateTagButton)}
            disabled={!this.state.isFormValid || !this.state.tagUid}
            onMouseEnter={() => this.setState({ isUntouched: false })}
          >
            {t('widgetActivateTag_activateTag')}
          </Button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    distributorId: state.auth.distributorId,
    customerId: state.auth.customerId,
    tagTypes: state.tagTypes.tagTypes,
    accessLevels: state.accessLevels.accessLevels,
    tagIsLoading: state.tags.isLoading,
    tagErrorMessage: state.tags.errorMessage,
    tagSuccessMessage: state.tags.successMessage,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getTagTypes: (customerId, pageParams) => dispatch(TagTypesActions.getTagTypesRequest(customerId, pageParams)),
  getAccessLevels: (customerId, pageParams) =>
    dispatch(AccessLevelsActions.getAccessLevelsRequest(customerId, pageParams)),
  activateTag: (tagInfos) => dispatch(TagsActions.activateTagRequest(tagInfos)),
  resetTagTypes: () => dispatch(TagTypesActions.resetTagTypes()),
  resetAccessLevels: () => dispatch(AccessLevelsActions.resetAccessLevels()),
});

export default compose(
  withTranslation(),
  withStyles(styles),
  withSize(),
  connect(mapStateToProps, mapDispatchToProps)
)(ActivateTag);
